import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';

import JvReport from './JvReport/JvReport';
import SalesByItem from './salesByItem/salesByItem';
import SalesByItemGrouped from './salesByItem/salesByItemGrouped';
import SalesBySerial from './salesBySerial/salesBySerial';
import ProfitLoss from './profitLoss/profitLoss';
import CustomerPrice from './customerPrice/customerPrice';

function OperationalReports(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, refProductData, devData, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;


  const items = [
    {
      key: '1',
      label: contentLanguages.SalesByInvoice,
      children: <JvReport isActive={true} isDebit={false} isOrder={false} type={['salesInvoice', 'PosSale']} />
    },
    {
      key: '2',
      label: contentLanguages.SalesByOrder,
      children: <JvReport isActive={true} isDebit={false} isOrder={true} type={['salesOrder', 'PosSaleOrder']} />
    },
    {
      key: '3',
      label: contentLanguages.SalesByItem,
      children: <SalesByItem />
    },
    {
      key: '4',
      label: contentLanguages.SalesByItemGrouped,
      children: <SalesByItemGrouped />
    },
    {
      key: '5',
      label: contentLanguages.SalesBySerial,
      children: <SalesBySerial />
    },
    {
      key: '6',
      label: contentLanguages.ProfitAndLoss,
      children: <ProfitLoss />
    },
    {
      key: '7',
      label: contentLanguages.CustomerPriceList,
      children: <CustomerPrice />
    },
    {
      key: '8',
      label: contentLanguages.ReturnByInvoice,
      children: <JvReport isActive={true} isDebit={true} isOrder={false} type={['returnInvoice', 'PosReturn']} />
    }
  ];


  return (

    <div style={{ alignItems: 'center', marginTop: '-1%' }}>
      <Tabs defaultActiveKey="1" centered={true} items={items}  destroyInactiveTabPane/>
    </div>

  )
}

export default OperationalReports;
